
import $ from 'jquery';
import 'slick-carousel';

//Hero slider
$(function () {
    $('.hero__slider-slides').slick({
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        arrows: false,
        dots: true,
    });
});

//Testimonial slider

$(document).ready(function () {
    $('.testimonials__slider').slick({
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: false,
        prevArrow: $('.testimonials__arrow--prev'),
        nextArrow: $('.testimonials__arrow--next')
    });
});


//Locations slider

jQuery(document).ready(function($) {
    $('#locations-slider .locations-slider__slides').slick({
        autoplay: false,
        infinite: false,
        arrows: false,
        dots: true,
        slidesToShow: 4,
        slidesToScroll: 2,
        centerMode: false,
        variableWidth: true,
        centerPadding: '20px',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]
    });
});
